<template>
  <div class="master-table-type">
    <el-table
      width="100%"
      :data="result"
      v-show="isShow"
      :fit="true"
    >
      <!--  会議室名 -->
      <el-table-column
        class-name="col-3"
        prop="meetingRoomName"
        :label="$t('label.system.meetingRoom.search.result.meetingRoomName')"
      />

      <!--  利用可能人数表示 -->
      <el-table-column
        class-name="col-2"
        prop="capacity"
        :label="$t('label.system.meetingRoom.search.result.capacity')"
      />

      <!--  オーナー名 -->
      <el-table-column
        class-name="col-4"
        prop="ownerName"
        :label="$t('label.system.meetingRoom.search.result.ownerName')"
      />

      <!--  ビル名 -->
      <el-table-column
        class-name="col-3"
        prop="buildingName"
        :label="$t('label.system.meetingRoom.search.result.buildingName')"
      />

      <!--  フロア名 -->
      <el-table-column
        class-name="col-2"
        prop="floorName"
        :label="$t('label.system.meetingRoom.search.result.floorName')"
      />

      <!--  エリア名 -->
      <el-table-column
        class-name="col-2"
        prop="areaName"
        :label="$t('label.system.meetingRoom.search.result.areaName')"
      />

      <!--   その他操作列   -->
      <el-table-column class-name="col-2">
        <div slot-scope="scope" class="detail-button with-100">
          <!--  照会バータン  -->
          <sp-smart-button @click="handleDetailAction(scope.row)" class="detailed-but with-100">{{$t('button.common.detail')}}</sp-smart-button>
        </div>
      </el-table-column>

       <el-table-column class-name="col-2" class="text-right">>
        <div slot-scope="scope" v-auth="{ auth: '020104'}" class="text-center">
          <el-popconfirm
            popper-class="iot-pop-confirm"
            :title="$t('message.system.owner.deleteConfirm')"
            :confirmButtonText="$t('button.common.ok')"
            :cancelButtonText="$t('button.common.cancel')"
            class="btn-operate"
            @onConfirm="handleDeleteAction(scope.row)">
            <sp-smart-button
              v-show="!scope.row.deleteFlag"
              slot="reference"
              class="button-width-100 margin-left-1">
              {{$t("button.common.data.delete")}}
            </sp-smart-button>
          </el-popconfirm>
        </div>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const EVENT_EDIT = "on-edit";
const EVENT_DETAIL = "on-detail";
const EVENT_DELETE = "on-delete";
import SpSmartButton from "@/components/common/sp-smart-button"

export default {
  name: "MeetingRoomSearchResultBeautify",
  components: { SpSmartButton },
  data() {
    return {};
  },
  props: {
    result: Array,
    isShow: Boolean,
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      //把每一行的索引放进row
      row.index = rowIndex;
    },
    //編集バータン
    onRowClick(row) {
      var index = row.index;
      this.$emit(EVENT_EDIT, this.result[index].meetingRoomId);
    },
    //照会バータン
    handleDetailAction(meetingRoom) {
      this.$emit(EVENT_DETAIL, meetingRoom.meetingRoomId);
    },
    //削除バータン
    handleDeleteAction(meetingRoom, index) {
      this.$emit(EVENT_DELETE, meetingRoom.meetingRoomId, index);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-operate {
  margin: 0 5px 0 0;
}
::v-deep .detail-button{
  button {
    width: 100%;
  }
  .my-button{
    width: 134px;
  }
}
::v-deep .detail-button .my-button {
  margin-left: 5px;
}
::v-deep .detail-button .my-button {
  width: 100%;
  height: 40px;
  line-height: 0;
}
</style>
